module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-packet-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Token")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.token),
      expression: "localValue.token"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localValue.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "token", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Destination")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.destination_type),
      expression: "localValue.destination_type"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localValue, "destination_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function () { return _vm.localValue.destination_id = null; }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an option")]), _vm._l((_vm.destinations), function(destination, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(destination))])
  })], 2), (_vm.localValue.destination_type === 'App\\Models\\Plan') ? _c('selectize-plan', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.localValue.destination_id),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "destination_id", $$v)
      },
      expression: "localValue.destination_id"
    }
  }) : _vm._e(), (_vm.localValue.destination_type === 'App\\Models\\CommonCost') ? _c('selectize-common-cost', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.localValue.destination_id),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "destination_id", $$v)
      },
      expression: "localValue.destination_id"
    }
  }) : _vm._e(), (_vm.localValue.destination_type === 'App\\Models\\Federation') ? _c('selectize-federation', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.localValue.destination_id),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "destination_id", $$v)
      },
      expression: "localValue.destination_id"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Additional"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additional_type),
      expression: "additional_type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.additional_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an option")]), _vm._l((_vm.destinations), function(destination, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(destination))])
  })], 2)]), (_vm.additional_type === 'App\\Models\\Plan') ? _c('selectize-plan', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.additional_id),
      callback: function($$v) {
        _vm.additional_id = $$v
      },
      expression: "additional_id"
    }
  }) : _vm._e(), (_vm.additional_type === 'App\\Models\\CommonCost') ? _c('selectize-common-cost', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.additional_id),
      callback: function($$v) {
        _vm.additional_id = $$v
      },
      expression: "additional_id"
    }
  }) : _vm._e(), (_vm.additional_type === 'App\\Models\\Federation') ? _c('selectize-federation', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.additional_id),
      callback: function($$v) {
        _vm.additional_id = $$v
      },
      expression: "additional_id"
    }
  }) : _vm._e(), _c('button', {
    staticClass: "small button",
    attrs: {
      "disabled": (_vm.additional_type === null || _vm.additional_id === null) && _vm.additional_type !== 'App\\Models\\PaymentMethod'
    },
    on: {
      "click": _vm.addAdditional
    }
  }, [_vm._v("Add")]), _vm._l((_vm.localValue.additional), function(value, i) {
    return _c('div', {
      staticClass: "prop-item"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-label"
    }, [_vm._v(_vm._s(value.class.split('\\')[value.class.split('\\').length - 1]))]), _c('input', {
      staticClass: "input-group-field",
      attrs: {
        "type": "text",
        "disabled": "disabled"
      },
      domProps: {
        "value": value.id
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button warning fa fa-times",
      on: {
        "click": function () {
          _vm.localValue.additional.splice(i, 1)
        }
      }
    })])])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d339bf3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/forms/RegistrationTokenForm.vue
// module id = 2571
// module chunks = 1